import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import {
  contractingKeys,
  dashboardKeys,
  profileItemKeys,
  searchProfileKeys,
} from "@/lib/query-keys";
import { capture } from "@/lib/posthog";
import type { ProfileItem } from "@/types/domain";

export function useUpdateProfileItems() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { items: ProfileItem[]; searchProfileId: number }) =>
      fetchToBackend<{ success: boolean }>("/searchprofileitems/updateAll", {
        method: "POST",
        body: JSON.stringify({
          items: vars.items.map((item) => ({
            keyword: item.keyword,
            active: item.active ?? true,
          })),
          searchProfileId: vars.searchProfileId,
        }),
      }),
    onSuccess: (_data, vars) => {
      capture("profile_items_updated", { count: vars.items.length });
      qc.invalidateQueries({
        queryKey: profileItemKeys.byProfile(vars.searchProfileId),
      });
      // El perfil sigue trayendo `searchprofile_keywords` hasta que se elimine.
      qc.invalidateQueries({ queryKey: searchProfileKeys.all });
      qc.invalidateQueries({ queryKey: contractingKeys.lists() });
      qc.invalidateQueries({ queryKey: dashboardKeys.all });
    },
  });
}
